export const getNumberOfTilesPerPage = (windowWidth: number): number => {
  if (windowWidth < 776) {
    return 60;
  } else if (windowWidth < 1035) {
    return 70;
  }
  return 100;
};
